import { Signal, computed } from '@angular/core';

/** Do'kon tanlagichining ko'rinishi va yagona do'kon. */
export interface StorePicker<T> {
  /**
   * Tanlashga muqobili yo'q do'kon — ro'yxatda aynan bitta bo'lsa.
   * FORMALARDA shu qiymat avtomatik qo'yiladi.
   */
  readonly single: Signal<T | null>;
  /** Tanlagich ekranda ko'rsatiladimi. */
  readonly visible: Signal<boolean>;
}

/**
 * Bitta do'konli biznesda do'kon tanlagichi ekrandan olib tashlanadi.
 *
 * <h3>Nima uchun</h3>
 * <p>
 * Bitta do'konli biznes — eng ko'p uchraydigan holat. Unda yagona variantli tanlagich
 * hech narsani hal qilmaydi, lekin har formada bitta ortiqcha bosish talab qiladi va
 * ba'zi joylarda o'sha bosishgacha keyingi maydonlarni bloklab turadi.
 * </p>
 *
 * <h3>Ikki xil qo'llanish</h3>
 * <ul>
 *   <li>
 *     <b>Formada</b> — do'kon avtomatik qo'yiladi va maydon yashiriladi. Qiymat
 *     baribir kerak: hujjat qaysi do'konga yozilishini server so'raydi.
 *   </li>
 *   <li>
 *     <b>Filtrda</b> — faqat yashiriladi, qiymat QO'YILMAYDI. Bo'sh filtr "hammasi"
 *     degani, bitta do'konda esa "hammasi" bilan "shu do'kon" bir xil natija beradi.
 *     Bekordan-bekor qiymat qo'yilsa, u so'rovga tushib, keyinchalik do'kon
 *     qo'shilganda ham eski filtr yopishib qolgandek ko'rinardi.
 *   </li>
 * </ul>
 *
 * <h3>Nol do'kon</h3>
 * <p>
 * Shart "aynan bitta" — "kamida bitta" emas. Do'kon umuman bo'lmaganda tanlagich
 * ko'rinib turadi: aks holda majburiy maydon haqidagi ogohlantirish hech qanday
 * maydonga ishora qilmasdi.
 * </p>
 */
export function storePicker<T extends { id: string }>(stores: Signal<T[]>): StorePicker<T> {
  const single = computed(() => (stores().length === 1 ? stores()[0] : null));
  return { single, visible: computed(() => single() === null) };
}
